import axios from '@/axios-mock'


export function getFilter (query) {
  return axios({
    url: `/app/search/filter?${query}`
  })
}

export function getMember () {
  return axios({
    url: `/app/member`,
    method: 'GET'
  })
  .then(({
    code,
    data
  }) => {
    return Promise.resolve(data)
  })
  .catch(err => {
    return Promise.reject(err)
  })
}


// WEBPACK FOOTER //
// ./static/components/navbar/apis.js